<template>
  <div>
    <div v-if="postDetails !== null">
      <div class="row">
        <p-button outline type="info" size="sm" round @click="$router.go(-1)">
          <i class="fa fa-chevron-circle-left"></i>
          Back
        </p-button>
      </div>
      <div class="row">
        <div class="card">
          <div class="row" v-if="postDetails !== null">
            <div class="col-md-6">
              <img :src="postDetails.imageUrlCache" alt v-if="postDetails.cached == true" />
              <img :src="postDetails.imageUrl" alt v-else />
            </div>
            <div class="col-md-6">
              <div class="row" style="margin-top:25px; margin-bottom:25px;">
                <div class="col-md-12">
                  <badge type="primary">{{postDetails.mediaType}}</badge>
                  <div style="margin-top:15px;" v-if="postDetails.postType == 'feed'">
                    View Post:
                    <a
                      :href="'https://instagram.com/p/'+ postDetails.shortcode"
                      target="_blank"
                    >https://instagram.com/p/{{postDetails.shortcode}}</a>
                  </div>
                  <hr />

                  <div v-if="postDetails.mediaType=='carousel'" class="row">
                    <div class="col-md-12" v-if="postDetails.carouselCache.length > 0">
                      <div
                        v-for="(slide, index) in postDetails.carouselCache"
                        :key="slide.shortcode"
                      >
                        <span v-if="typeof slide.videoUrlCache !=='undefined'">
                          <p-button
                            type="danger"
                            size="sm"
                            @click="downloadFile(slide.videoUrlCache)"
                            round
                          >
                            <i class="far fa-arrow-alt-circle-down"></i>
                            Slide Video {{index+ 1}}
                          </p-button>
                          <p-button
                            type="info"
                            size="sm"
                            @click="downloadFile(slide.imageUrlCache)"
                            round
                          >
                            <i class="far fa-arrow-alt-circle-down"></i>
                            Slide Image {{index+ 1}}
                          </p-button>
                        </span>
                        <span v-else>
                          <p-button
                            type="info"
                            size="sm"
                            @click="downloadFile(slide.imageUrlCache)"
                            round
                          >
                            <i class="far fa-arrow-alt-circle-down"></i>
                            Slide Image {{index+ 1}}
                          </p-button>
                        </span>
                      </div>
                    </div>
                    <div class="col-md-12" v-else-if="postDetails.carouselMedia.length > 0">
                      <div
                        v-for="(slide, index) in postDetails.carouselMedia"
                        :key="slide.shortcode"
                        style="float:left;"
                      >
                        <span v-if="slide.mediaType == 'video'">
                          <p-button
                            type="danger"
                            size="sm"
                            @click="downloadFile(slide.videoUrl)"
                            round
                          >
                            <i class="far fa-arrow-alt-circle-down"></i>
                            Slide Video {{index+ 1}}
                          </p-button>
                          <p-button
                            type="info"
                            size="sm"
                            @click="downloadFile(slide.displayUrl )"
                            round
                          >
                            <i class="far fa-arrow-alt-circle-down"></i>
                            Slide Image {{index+ 1}}
                          </p-button>
                        </span>
                        <span v-else>
                          <p-button
                            type="info"
                            size="sm"
                            @click="downloadFile(slide.displayUrl )"
                            round
                          >
                            <i class="far fa-arrow-alt-circle-down"></i>
                            Slide {{index+ 1}}
                          </p-button>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="postDetails.mediaType=='video'">
                    <p-button
                      type="danger"
                      size="sm"
                      @click="downloadFile(postDetails.videoUrlCache)"
                      round
                      v-if="typeof postDetails.videoUrlCache !='undefined'"
                    >
                      <i class="far fa-arrow-alt-circle-down"></i> Download Video
                    </p-button>
                    <p-button
                      type="danger"
                      size="sm"
                      @click="downloadFile(postDetails.videoUrl)"
                      round
                      v-else
                    >
                      <i class="far fa-arrow-alt-circle-down"></i> Download Video
                    </p-button>
                    <p-button
                      size="sm"
                      type="info"
                      @click="downloadFile(postDetails.imageUrlCache)"
                      v-if="typeof postDetails.imageUrlCache !='undefined'"
                      round
                    >
                      <i class="far fa-arrow-alt-circle-down"></i> Download Image
                    </p-button>
                    <p-button
                      size="sm"
                      type="info"
                      @click="downloadFile(postDetails.imageUrl)"
                      v-else
                      round
                    >
                      <i class="far fa-arrow-alt-circle-down"></i> Download Image
                    </p-button>
                  </div>
                  <div v-if="postDetails.mediaType=='image'">
                    <p-button
                      size="sm"
                      type="info"
                      @click="downloadFile(postDetails.imageUrlCache)"
                      v-if="typeof postDetails.imageUrlCache !='undefined'"
                      round
                    >
                      <i class="far fa-arrow-alt-circle-down"></i> Download Image
                    </p-button>
                    <p-button
                      size="sm"
                      type="info"
                      @click="downloadFile(postDetails.imageUrl)"
                      v-else
                      round
                    >
                      <i class="far fa-arrow-alt-circle-down"></i> Download Image
                    </p-button>
                  </div>

                  <div
                    style="margin-top:15px; white-space: pre-wrap; display:none;"
                    v-if="postDetails.postType=='feed'"
                  >
                    <p style="font-weight: bold;">Caption:</p>
                    <p style="white-space: pre-wrap;">{{postDetails.caption}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="lds-dual-ring"></div>
    </div>
  </div>
</template>
<script>
import firebase from "firebase";

import _ from "underscore";
import { VueAutosuggest } from "vue-autosuggest";
import {
  loadInstagramProfile,
  instagramPostDetailsApi,
  influencerCampaignReadApi,
  influencerCollaborationListApi,
  userLoadApi,
  influencerCollabPostAddApi,
  influencerCollabPostCheckApi,
  influencerCollabPostArchiveApi
} from "@/config/appSettings";
import { mapGetters, mapActions } from "vuex";
import store from "@/store/index.js";
import { getPostData } from "@/libs/ig/postData";
import { Badge } from "src/components/UIComponents";
import Axios from "axios";
export default {
  data: () => ({
    auth: null,
    loadingOverlay: false,
    loadingOverlayText: null,
    profile: null,
    instagramProfile: null,
    profileSearch: null,
    postDetails: null,
    currentInstagram: null,
    campaigns: [],
    selectCollaboration: null,
    collabFormProps: null,
    campaignDropdown: [],
    currentInstagramId: null,
    collabPostsActive: [],
    openCampaigns: [],
    totalPostEngagement: null,
    postEngagementRate: null,
    hashtagsUsed: [],
    hashtagsRanked: []
  }),
  components: {
    VueAutosuggest,
    [Badge.name]: Badge
  },
  name: "InstagramPostDetail",
  methods: {
    async loadPost() {
      // THIS IS PAGE
      let loadPostUrl = `${instagramPostDetailsApi}/?usertoken=${this.auth}&shortcode=${this.$route.params.shortcode}`;
      //console.log("LOAD POST URL:", loadPostUrl)
      let instagramPostResponse = await Axios.get(loadPostUrl);
      //console.log("POST DATA:", instagramPostResponse.data )
      this.postDetails = instagramPostResponse.data.result.post;
    },
    async downloadFile(url) {
      //console.log("URL", url);
      window.open(url);
      //window.location = url
    },
    async loadPageContent() {
      // THIS IS PAGE
      this.loadingOverlay = true;
      this.loadingOverlayText = "Loading...";
      await this.loadPost();
      this.loadingOverlay = false;

      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
  },

  mounted() {
    this.auth = firebase.auth().currentUser.uid;
    this.loadPageContent();
  }
};
</script>

<style scoped>
html {
  overflow-y: scroll !important;
}
</style>